import { render, staticRenderFns } from "./CompanyBrandingForm.vue?vue&type=template&id=715cda04"
import script from "./CompanyBrandingForm.vue?vue&type=script&lang=js"
export * from "./CompanyBrandingForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports